import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import shortid from "shortid";

const Accordion = styled.div`
  width: min(90%, 800px);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
`;

const AccordionTitleContainer = styled.div`
  width: 100%;
  background-color: var(--black);
  min-height: 50px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  padding: 10px 30px;
  border: 0.3px solid var(--light-grey);
  @media (max-width: 576px) {
    padding: 10px 20px;
  }
`;

const AccordionTitle = styled.h3`
  font-family: var(--raleway);
  color: var(--white);
  font-size: 1rem;
  line-height: 1.5rem;
  z-index: 2;
  @media (max-width: 576px) {
    font-size: 0.9rem;
  }
`;

const Icon = styled.p`
  color: var(--white);
  font-weight: 300;
  font-family: var(--raleway);
  font-size: 2rem;
  padding-top: 0.2rem;
  @media (max-width: 576px) {
    padding-top: 0px;
    font-size: 1.5rem;
  }
`;

const AccordionContent = styled.div`
  width: 100%;
  background-color: var(--white);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  padding: 30px;
  font-family: var(--roboto);
  color: var(--grey);
  font-size: 1rem;
  font-weight: 300;
  overflow-y: hidden;
  ul {
    display: flex;
    flex-direction: column;
    gap: 15px;
    li {
      span {
        font-weight: 400;
        color: var(--blue-grey);
      }
    }
  }
`;

const AccordionItem = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <>
      <AccordionTitleContainer onClick={() => setIsActive(!isActive)}>
        <AccordionTitle>{title}</AccordionTitle>
        <Icon>
          {isActive ? (
            <FontAwesomeIcon icon={faAngleUp} />
          ) : (
            <FontAwesomeIcon icon={faAngleDown} />
          )}
        </Icon>
      </AccordionTitleContainer>
      {isActive && (
        <AccordionContent
          dangerouslySetInnerHTML={{ __html: content }}
        ></AccordionContent>
      )}
    </>
  );
};

const Acordion = ({ items }) => {
  return (
    <Accordion data-aos="fade-right">
      {items.map((item, index) => {
        return (
          <AccordionItem
            key={shortid.generate()}
            title={item.title}
            content={item.content}
          />
        );
      })}
    </Accordion>
  );
};

export default Acordion;
